import React, { useEffect, useRef, useState } from "react";
import { BoxButton } from "shared";
import { Email } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import useTherapist from "../queries/useTherapist";
import useResendTherapistInvitation from "../queries/useResendTherapistInvitation";
import { useErrorContext } from "shared/ErrorModal";
import { getDate } from "utils/time";

const ResendInvitation: React.VFC = () => {
  const { t } = useTranslation();
  const setError = useErrorContext();
  const { data: pt } = useTherapist();
  const { mutateAsync, isLoading } = useResendTherapistInvitation();
  const [sent, setSent] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    },
    []
  );

  if (!pt?.id || pt.state !== "in_onboarding") return null;

  const lastSentAt: string | null = pt.last_invitation_sent_at ?? null;

  const handleResend = async () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setSent(false);
    try {
      await mutateAsync(pt.id);
      setSent(true);
      timeoutRef.current = setTimeout(() => setSent(false), 4000);
    } catch (err) {
      setError(t("therapists.resend_invitation_error"), err);
    }
  };

  return (
    <>
      <BoxButton startIcon={<Email />} onClick={handleResend} disabled={isLoading}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          {sent ? t("therapists.resend_invitation_sent") : t("therapists.resend_invitation")}
          {lastSentAt && (
            <div style={{ fontSize: 12, color: "#888" }}>
              {t("therapists.last_invitation_sent_at")}: {getDate(lastSentAt)}
            </div>
          )}
        </div>
      </BoxButton>
    </>
  );
};

export default ResendInvitation;
